import { useTranslation } from 'react-i18next'
import { ReactNode } from 'react'

// local imports
import { INotificationFirmData } from 'types/DashboardType'
import { saveAsExcelFile } from 'utils/Miscellaneous'
import ExportBtn from './ExportBtn'

interface CompProps {
  children: ReactNode
  excelData: any
}

export default function NotificationDist({ excelData, children }: CompProps) {
  const { t } = useTranslation()

  const handleExport = () => {
    import('xlsx').then((xlsx) => {
      let heading = [
        [
          t('most-used-words.firm'),
          t('most-used-words.location'),
          t('dashboard.firm-office-notification'),
          t('dashboard.shared-office-notification'),
          t('dashboard.remote-office-notification'),
          t('dashboard.num-of-all-notification'),
        ],
      ]

      const arr = excelData?.map((res: any) => {
        const {
          firmName,
          locationName,
          officeReservationCount,
          sharedOfficeReservationCount,
          homeOfficeReservationCount,
          totalReservationCount,
        } = res || {}

        return {
          firmName: firmName || '---',
          locationName: locationName || '',
          officeReservationCount: officeReservationCount,
          sharedOfficeReservationCount: sharedOfficeReservationCount,
          homeOfficeReservationCount: homeOfficeReservationCount,
          totalReservationCount: totalReservationCount,
        }
      })

      const totalRow = arr.reduce(
        (acc: INotificationFirmData, curr: INotificationFirmData) => {
          acc.officeReservationCount += curr.officeReservationCount || 0
          acc.sharedOfficeReservationCount += curr.sharedOfficeReservationCount || 0
          acc.homeOfficeReservationCount += curr.homeOfficeReservationCount || 0
          acc.totalReservationCount += curr.totalReservationCount || 0
          return acc
        },
        {
          firmName: '',
          locationName: t('most-used-words.total'),
          officeReservationCount: 0,
          sharedOfficeReservationCount: 0,
          homeOfficeReservationCount: 0,
          totalReservationCount: 0,
        }
      )

      let heading2 = {
        firmName: '',
        officeReservationCount: t('dashboard.excel.total-office-res'),
        sharedOfficeReservationCount: t('dashboard.excel.total-shared-res'),
        homeOfficeReservationCount: t('dashboard.excel.total-home-res'),
        totalReservationCount: t('dashboard.excel.total-notification-res'),
      }

      arr.push(...[{}, heading2, totalRow])

      /* header */
      const ws = xlsx.utils.book_new()
      xlsx.utils.sheet_add_aoa(ws, heading)
      const worksheet = xlsx.utils.sheet_add_json(ws, arr!, { origin: 'A2', skipHeader: true })
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] }
      const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' })
      saveAsExcelFile(excelBuffer, t('dashboard.excel.not-file-name'))
    })
  }

  return (
    <>
      {!!excelData && excelData?.length ? <ExportBtn handleExport={handleExport} /> : null}
      {children}
    </>
  )
}
